export enum KeyCodes {
    DOWN = 40,
    ESCAPE = 27,
    LEFT = 37,
    RETURN = 13,
    RIGHT = 39,
    SPACE = 32,
    TAB = 9,
    UP = 38
}

export default KeyCodes;
